import { useEffect, useState } from "react"

type useFeedArguments = {
    cycleTimeSeconds: number
}

// Cycle through elements in a list with a time delay.
export const useFeed = <T,>(items: T[], args: useFeedArguments) =>  {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        const id = setInterval(() => setIndex(i => (i + 1) % items.length), args.cycleTimeSeconds*1000)
        return () => clearInterval(id)
    }, [items, args])

    if (index >= 0 && index < items.length) {
        return items[index]
    } else if (items.length > 0) {
        setIndex(0)
        return items[0]
    }

    return undefined
}